export class FormSchemaUtil {
  static readonly timeRegex: RegExp = /^(0?[1-9]|1[0-2]):([0-5][0-9])$/;

  static checkIfDayInPast(date: Date) {
    const startOfDay = new Date();
    startOfDay.setHours(0, 0, 0, 0);
    return date >= startOfDay;
  }

  static isTime(time: string) {
    return FormSchemaUtil.timeRegex.test(time);
  }

  static combineDateTime(date: Date, time: string, meridian: "AM" | "PM") {
    let [hours, minutes] = time.split(":").map(Number);
    if (meridian === "PM" && hours < 12) {
      hours += 12;
    } else if (meridian === "AM" && hours === 12) {
      hours = 0;
    }
    const dateTime = new Date(date);
    dateTime.setHours(hours, minutes);
    return dateTime;
  }

  _combineDateTime(date: Date, time: string, meridian: "AM" | "PM") {
    let [hours, minutes] = time.split(":").map(Number);
    if (meridian === "PM" && hours < 12) {
      hours += 12;
    } else if (meridian === "AM" && hours === 12) {
      hours = 0;
    }
    const dateTime = new Date(date);
    dateTime.setHours(hours, minutes);
    return dateTime;
  }
}
